import { Columns } from "../colunms.entity";
import { ColumnsDTO } from "./columns.dto";





export class ColumnsAdapter {

    public convertDtoToEntity(details: ColumnsDTO): Columns {
        const columns = new Columns();
        if(details.columnsId){
            columns.columnsId = details.columnsId;
            columns.updatedUser =details.updatedUser;
        }
        columns.columnsCode = details.columnsCode;
        columns.columnsNo = details.columnsNo;
        columns.createdUser =details.createdUser;
        return columns;
    }
    
}